import axios, { AxiosResponse, AxiosError } from "axios";
import store from "../features/store/store";
import { updateUserTokenToInvalid } from "../features/login/loginSlice";
import { toast } from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export const axiosRequests = {
  get: <T>(url: string) => axiosPrivate.get<T>(url).then(responseBody),
  getRouteStatus: <T>(url: string) => 
    axiosPrivate.get<T>(url, { headers: { Authorization: process.env.REACT_APP_API_KEY as string, }, }).then(responseBody),
  getWithQueryParam: <T>(url: string, params: Object) =>
    axiosPrivate.get<T>(url, params).then(responseBody),
  getWithQueryParamAndReturnBlob: <T>(url: string, params: Object) =>
    axiosPrivate.get<T>(url, params).then((response) => response),
  post: <T>(url: string, body: {}, config?: {}) =>
    axiosPrivate.post<T>(url, body, config).then(responseBody),
  postWithQueryParamAndReturnBlob: <T>(url: string, body: {}, params: Object) =>
    axiosPrivate.post<T>(url, body, params).then((response) => response),
  postWithFormData: <T>(url: string, body: FormData, config?: object) =>
    axiosPrivate.post<T>(url, body, config).then(responseBody),
  put: <T>(url: string, body: {}) =>
    axiosPrivate.put<T>(url, body).then(responseBody),
  putWithFormData: <T>(url: string, body: FormData, config?: object) =>
    axiosPrivate.put<T>(url, body, config).then(responseBody),
  delete: <T>(url: string) => axiosPrivate.delete<T>(url).then(responseBody),
  deleteWithQueryParam: <T>(url: string, params: Object) =>
    axiosPrivate.delete<T>(url, params).then(responseBody),
  postXlsx: <T>(url: string, body: {}) =>
    axiosPrivate
      .post<T>(url, body, {
        responseType: "blob",
      })
      .then(responseBody),
};

export const axiosPrivate = axios.create({
  withCredentials: true,
  // timeout: 180000,
  headers: {
    "X-Source": "command-ops-v2",
  },
});

export const axiosImageUploadRequest = {
  post: <T>(url: string, formData: FormData) =>
    axios
      .post<T>(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Source": "command-ops-v2",
        },
        withCredentials: true,
      })
      .then(responseBody),
};

axiosPrivate.interceptors.request.use((request) => {
  request.headers["X-Source"] = "command-ops-v2";
  // console.log('Starting Request: ', JSON.stringify(request, null, 2))
  return request;
});

axiosPrivate.interceptors.response.use((response) => {
  // console.log('Response: ', JSON.stringify(response, null, 2))
  return response;
});

axiosPrivate.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      const customError = {
        code: error.response.status.toString(),
        message: error.response.data,
        name: error.response.statusText,
        stack: error.stack,
      };
      if (error.response.status === 403 || error.response.status === 401) {
        localStorage.removeItem("isLoggedIn");
        store.dispatch(updateUserTokenToInvalid(false));
      }
      return Promise.reject(customError);
    }
    return Promise.reject(error);
  }
);
